import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
//FOR MAP BOX
import "mapbox-gl/dist/mapbox-gl.css";
//

ReactDOM.createRoot(document.getElementById("root")).render(<App />);

